import type { PrivacyPageLocaleContent } from '../types'

export const privacyPageEn: PrivacyPageLocaleContent = {
  dateLocale: 'en-GB',
  title: 'Privacy Policy - Toolvance',
  description: 'Privacy policy for Toolvance.',
  metadata: {
    ogTitle: 'Privacy Policy - Toolvance',
    ogDescription: 'Privacy policy for Toolvance.',
    robots: 'noindex',
  },
  content: {
    heading: 'Privacy Policy',
    updatedLabel: 'Last updated',
    sections: [
      {
        heading: 'What we collect',
        body: 'Toolvance is a static website. We do not collect, store, or process any personally identifiable information. All calculator computations occur entirely within your browser and no calculation data is sent to any server.',
      },
      {
        heading: 'Analytics',
        body: 'We may use anonymised analytics to understand which calculators are most popular. No personally identifiable data is collected or stored.',
      },
      {
        heading: 'Cookies',
        body: 'This website does not use cookies for tracking or advertising purposes.',
      },
      {
        heading: 'Third-party services',
        body: 'We do not share data with third parties because we do not collect any data to share.',
      },
    ],
    contactHeading: 'Contact',
    contactPrefix: 'If you have questions about this privacy policy, please ',
    contactLinkText: 'contact us',
    contactSuffix: '.',
  },
}
